/* Retrograde FAQ page (rg-faq): accordion, auto-built jump tabs, scroll spy, theme editor support */
(function () {
  if (window.rgfqLoaded) return;
  window.rgfqLoaded = true;

  function setOpen(item, open) {
    if (!item) return;
    item.classList.toggle('is-open', open);
    var btn = item.querySelector('.rgfq-q');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Email links: open the visitor's email app in place. Site scripts add target="_blank" to
  // mailto links after load, which leaves an empty tab behind in some browsers.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.rgfq a[href^="mailto:"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    a.removeAttribute('target');
    window.location.href = a.getAttribute('href');
  }, true);

  // Accordion (event delegation, so sections added in the editor work too)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rgfq-q');
    if (!btn) return;
    var item = btn.closest('.rgfq-item');
    setOpen(item, !item.classList.contains('is-open'));
  });

  // Jump tabs: built from every FAQ category section on the page, in page order
  function buildTabs() {
    var list = document.querySelector('[data-rgfq-tabs]');
    if (!list) return;
    list.querySelectorAll('[data-rgfq-auto]').forEach(function (li) { li.remove(); });
    var extra = list.querySelector('[data-rgfq-extra]');
    document.querySelectorAll('[data-rgfq-cat]').forEach(function (sec) {
      var li = document.createElement('li');
      li.setAttribute('data-rgfq-auto', '');
      var a = document.createElement('a');
      a.href = '#' + sec.id;
      var icon = sec.querySelector('.rgfq-section__icon svg');
      if (icon) a.appendChild(icon.cloneNode(true));
      a.appendChild(document.createTextNode(sec.getAttribute('data-rgfq-tab') || ''));
      li.appendChild(a);
      list.insertBefore(li, extra || null);
    });
    spy();
  }

  function spy() {
    var list = document.querySelector('[data-rgfq-tabs]');
    if (!list) return;
    var links = [].slice.call(list.querySelectorAll('a'));
    if (!links.length) return;
    var offset = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--rgfq-sticky-top'), 10) || 0) + 90;
    var current = links[0];
    links.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t && t.getBoundingClientRect().top <= offset) current = a;
    });
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) current = links[links.length - 1];
    links.forEach(function (a) {
      var on = a === current;
      if (on === a.classList.contains('is-active')) return;
      a.classList.toggle('is-active', on);
      if (on) {
        var lr = list.getBoundingClientRect(), ar = a.getBoundingClientRect();
        if (ar.left < lr.left + 8) list.scrollLeft += ar.left - lr.left - 20;
        else if (ar.right > lr.right - 8) list.scrollLeft += ar.right - lr.right + 20;
      }
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; spy(); });
  }, { passive: true });

  // Open a question when arriving with #question-anchor in the URL
  function openFromHash() {
    if (!location.hash) return;
    var el = document.getElementById(location.hash.slice(1));
    if (el && el.classList.contains('rgfq-item')) setOpen(el, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { buildTabs(); openFromHash(); });
  } else { buildTabs(); openFromHash(); }
  window.addEventListener('hashchange', openFromHash);

  // Theme editor: rebuild tabs when sections change; open the selected question
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(buildTabs, 0); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.rgfq-item') : null;
    if (item) setOpen(item, true);
  });
})();